import {
  Badge,
  Box,
  Flex,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Text,
} from '@chakra-ui/react'
import { useProfile } from '@contexts/user/ProfileContext'
import { useMemo } from 'react'
import { AllergyDetailBody, getGynAllergyDisplayRows } from '../../allergyUtils'
import { SectionLabel } from '../../SectionLabel'

export const ExamAllergiesView = () => {
  const { user } = useProfile()
  const rows = useMemo(
    () => getGynAllergyDisplayRows(user?.gyn?.mergedData?.allergies),
    [user?.gyn?.mergedData?.allergies],
  )

  return (
    <Box w="100%">
      <SectionLabel>Allergies</SectionLabel>
      {rows.length === 0 ? (
        <Text fontSize="sm" color="gray.500">
          No documented allergies in chart.
        </Text>
      ) : (
        <Flex flexWrap="wrap" gap={2} align="center">
          {rows.map(row => (
            <Popover key={row.id} placement="bottom-start" isLazy trigger="hover">
              <PopoverTrigger>
                <Badge
                  px={2}
                  py={1}
                  borderRadius="md"
                  fontSize="sm"
                  colorScheme="orange"
                  variant="subtle"
                  fontWeight={600}>
                  {row.label}
                </Badge>
              </PopoverTrigger>
              <Portal>
                <PopoverContent w="280px" boxShadow="md">
                  <PopoverArrow />
                  <PopoverBody>
                    <Text fontWeight={700} fontSize="sm" mb={2}>
                      {row.label}
                    </Text>
                    <AllergyDetailBody row={row} />
                  </PopoverBody>
                </PopoverContent>
              </Portal>
            </Popover>
          ))}
        </Flex>
      )}
    </Box>
  )
}
